import styled from 'styled-components'

interface IChatCommentStyledProps {
  isFromMe?: boolean
}

export const ChatCommentStyled = styled.div<IChatCommentStyledProps>`
  font-size: ${(props) => props.theme.typography.pxToRem(16)};

  .comment {
    padding: ${(props) => props.theme.space.medium};
    font-weight: ${(props) => props.theme.fontWeights.normal};

    background: ${(props) =>
      props.isFromMe
        ? props.theme.colors.comments.self.background
        : props.theme.colors.comments.others.background};

    border-radius: ${(props) => props.theme.typography.pxToRem(8)};
  }

  .comment-author {
    font-weight: ${(props) => props.theme.fontWeights.bold};
  }

  .comment-header + .comment-date {
    margin-top: 0.25em;

    color: ${(props) => props.theme.colors.textSecondary};
  }

  .mention {
    color: ${(props) => props.theme.colors.text.link};
    font-weight: ${(props) => props.theme.fontWeights.bold};
  }
`
